export interface FpsMonitorOpts {
  windowFrames: number;
  threshold: number;
  sustainSec: number;
  onDowngrade: () => void;
}

export class FpsMonitor {
  private samples: number[] = [];
  private slowSince: number | null = null;
  private fired = false;
  constructor(private opts: FpsMonitorOpts) {}

  tick(nowSec: number, dt: number) {
    if (this.fired) return;
    const fps = dt > 0 ? 1 / dt : 0;
    this.samples.push(fps);
    if (this.samples.length > this.opts.windowFrames) this.samples.shift();

    const avg = this.samples.reduce((a, b) => a + b, 0) / this.samples.length;
    if (avg < this.opts.threshold) {
      if (this.slowSince === null) this.slowSince = nowSec - dt;
      else if (nowSec - this.slowSince >= this.opts.sustainSec - 1e-9) {
        this.fired = true;
        this.opts.onDowngrade();
      }
    } else {
      this.slowSince = null;
    }
  }
}
